


















































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { CommonModule } from '@/store/modules/common'
@Component({
  name: 'special',
  components: {}
})
export default class Special extends Vue {
  created() {
    // 获取当前语言
    const data = (this.$route.query.language as string) || 'ug'
    this.getLanguage(data)
    CommonModule.setLanguage(data)
  }

  get contents() {
    if (this.language === 'ug') {
      return [
        require('@/assets/pic_01@2x.png'),
        require('@/assets/pic_02@2x.png'),
        require('@/assets/pic_03@2x.png'),
        require('@/assets/pic_04@2x.png')
      ]
    }
    return [
      require('@/assets/pic_05@2x.png'),
      require('@/assets/pic_06@2x.png'),
      require('@/assets/pic_07@2x.png'),
      require('@/assets/pic_08@2x.png')
    ]
  }

  // 当前语言
  get language() {
    return this.$i18n.locale
  }

  // 切换语言
  getLanguage(language: string) {
    this.$i18n.locale = language
  }

  //返回
  handelback() {
    this.$router.back()
  }
}
